// extracted by mini-css-extract-plugin
export default {"Arrow":"NewSortButton_Arrow__tMUi-","Sort":"NewSortButton_Sort__69Nlg"};